import React, {Component} from 'react';

import {Row, Col, Input, Button} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {PulseLoader} from 'halogenium';
import axios from 'axios';
import moment from  'moment';
import 'moment/locale/sr';
import _ from 'lodash';

import {serverPath} from '../common.js';

import SubmissionList from './SubmissionListComponent.js';
import SubmissionOptionsModals from './submissionOptions/SubmissionOptionsModalsComponent.js';




class CourseSubmissions extends Component
{

	constructor(props)
	{
		super(props);

		this.state =
			{
				submissions:[], 
				user:{userId:0},
				dateTo:moment(),
				dateFrom:moment().subtract(7,'d'),
				dateInputEnabled:false,
				radioButtonSelected:2,
				loading:true,
				forceUpdate:false,
				stop:false

			};

		this.onSubmissionListChange = this.onSubmissionListChange.bind(this);
		this.renderBody = this.renderBody.bind(this);
		this.allTimeSelected = this.onOptionSelected.bind(this, 0);
		this.schoolYearSelected = this.onOptionSelected.bind(this, 1);
		this.lastSevenDaysSelected = this.onOptionSelected.bind(this,2);
		this.customSelected = this.onOptionSelected.bind(this,3);
		this.onStartDateChange = this.onDateChange.bind(this, 0);
		this.onEndDateChange= this.onDateChange.bind(this, 1);
		this.onApplyFilter=this.onApplyFilter.bind(this);
		this.onStop = this.onStop.bind(this);
	}

	async getFromLink(link)
	{
		let response = null;
		let onRecive = (prevState)=>
				{
					return {
						submissions:prevState.submissions.concat(response.data.submissions),
						forceUpdate:!prevState.forceUpdate
					};
				};

		while(!this.state.stop)
		{
			response = await axios.get(link);	

			if(!response)
			{
				break;
			}
			
			this.setState(onRecive);
			if(_.has(response.data, 'next'))
			{
				link = response.data.next;
			}
			else
			{
				break;
			}

		}
		this.setState({loading:false, stop:false});
	}

	getData()
	{
		axios.get(serverPath + 'professorService.php', 
			{
				params:
				{
					action:'getSubmissions',
					courseId:this.props.match.params.courseId,
					from: this.state.dateFrom.format('X'),
					to: this.state.dateTo.format('X'),
					filter:'all',
					limit:100,
					forceUpdate:false
				}
			})
			.then((response)=>
				{
					this.setState(
						{
							submissions:response.data.submissions.map((submission)=>{
								//this is added so that only submissions with review requests for this professor are
								// colored in red in SubmissionListComponent(line 171, or somewhere near)
								submission.hasReviewForLoggedProfessor = submission.reviewer !== null
									&& submission.reviewer === this.state.user.userId;
								return submission;
							}),
							forceUpdate:!this.state.forceUpdate
						});

					if(_.has(response.data, 'next'))
					{
						this.getFromLink(response.data.next);
					}
					else
					{
						this.setState({loading:false});
					}
				});
	}

	/**
	 * @description Use this function to auth user
	 **/
	componentDidMount()
	{
		axios.get(serverPath + "authService.php", {params:{action: 'whoIsLoggedIn'}})
			.then((response) =>
				{

					if(response.data !== null && response.data.roleName === "professor")
					{
						this.setState({user:response.data})
						this.getData();
					}
					else
					{
						this.props.history.push('/home');
					}
				});
	}
	
	onSubmissionListChange(submissionId, codeReview)
	{
		const index = this.state.submissions.findIndex((el)=>
			{

				return el.idProblemSubmission === submissionId;
			});

		this.setState((prevState)=>
			{
				var prev = prevState.submissions.slice(0, index);
				var next = prevState.submissions.slice(index+1);
				var curr = prevState.submissions[index];
				curr = {...curr, codeReview:codeReview, anwsered:true};
				return {
					submissions: prev.concat([curr], next),
					forceUpdate:!this.state.forceUpdate
				};
			});
	}

	onOptionSelected(id)
	{
		let payload = {dateInputEnabled:false, radioButtonSelected:id};

		if(id === 0)
		{
			payload.dateFrom = moment.unix(0);
			payload.dateTo  = moment();
		}
		else if(id === 1)
		{
			payload.dateFrom = moment('10-01', 'MM-DD');
			let now = moment();
			payload.dateTo = payload.dateFrom.clone().add(1, 'y');	
			if(!now.isBetween(payload.dateFrom, payload.dateTo))
			{
				payload.dateFrom.subtract(1,'y');
				payload.dateTo.subtract(1,'y');
			}
		}
		else if(id === 2)
		{
			payload.dateTo= moment();
			payload.dateFrom= moment().subtract(7, 'd');
		}
		else
		{
			payload.dateInputEnabled = true;

		}
		
		this.setState(payload);
	}


	onDateChange(id, date)
	{
		/*User has changed start date*/
		if(id === 0)
		{
			this.setState({dateFrom:date});	
		}
		else
		{
			this.setState({dateTo:date});
		}
	}

	onApplyFilter()
	{
		this.setState({loading:true});
		this.getData();
	}

	onStop()
	{
		if(!this.state.stop)
		{
			this.setState({stop:true});
		}
	}

	renderBody(callbacks)
	{
		let checkedArr = [false, false, false, false];
		checkedArr[this.state.radioButtonSelected] = true;


		return (
			<React.Fragment>

				<Row className='justify-content-center'>
					<Col xs='auto'>
						<label>
							<Input type='radio' name='filterType' onChange={this.allTimeSelected}
								checked={checkedArr[0]}/>
							All time
						</label>
					</Col>

					<Col xs='auto'>
						<label>
							<Input type='radio' name='filterType' 
								onChange={this.schoolYearSelected}
								checked={checkedArr[1]}/>
							Ova skolska godina
						</label>
					</Col>

					<Col xs='auto'>
						<label>
							<Input type='radio' name='filterType'
								onChange={this.lastSevenDaysSelected}
								checked={checkedArr[2]}
							/>
							Poslednjih 7 dana
						</label>
					</Col>

					<Col xs='auto'>
						<label>
							<Input type='radio' name='filterType'
								onChange={this.customSelected}
								checked={checkedArr[3]}
							/>
							Rucno
						</label>
					</Col>
				</Row>

				<Row className='justify-content-center mb-2'>
					<Col xs='auto'>
						<DatePicker 
							selectsStart
							locale='sr'
							dateFormat='ll'
							selected={this.state.dateFrom}
							startDate={this.state.dateFrom}
							endDate={this.state.dateTo}
							disabled={!this.state.dateInputEnabled}
							onChange={this.onStartDateChange}
							className='date-picker'
						/>
					</Col>

					<Col xs='auto'>
						<DatePicker 
							selectsEnd
							locale='sr'
							dateFormat='ll'
							selected={this.state.dateTo}
							startDate={this.state.dateFrom}
							endDate={this.state.dateTo}
							disabled={!this.state.dateInputEnabled}
							onChange={this.onEndDateChange}
							className='date-picker'
						/>
					</Col>
				</Row>

				<Row className='mb-2'> 
					<Col>
						<Button block={true}
							onClick={this.onApplyFilter}
							disabled={this.state.loading}
						>
							{
								this.state.loading ?
									(<PulseLoader />)
									:
									('Primeni filter')
							}
						</Button>
					</Col>
					{
						this.state.loading &&

						<Col xs='auto'>
							<Button 
								onClick={this.onStop}
								color='danger'
							>
								<span className='fa fa-times'></span>
							</Button>

						</Col>
					}
				</Row>

				<Row>
					<Col>
						<SubmissionList submissions={this.state.submissions} {...callbacks}
							forceUpdate={this.state.forceUpdate}/>
					</Col>
				</Row>
			</React.Fragment>
		);
	}

	render()
	{
		return (
			<SubmissionOptionsModals userId={this.state.user.userId}
				onSubmissionListChanged={this.onSubmissionListChange}
				render={this.renderBody}
			/>
		);
	}

}

export default CourseSubmissions;
